var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPtFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_341_12349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.7656C0 17.9252 3.2565 22.3237 7.82602 24.0192L8.86955 12.7656L7.82602 1.51202C3.2565 3.20759 0 7.60606 0 12.7656Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 12.7656C24 6.13825 18.6274 0.765625 12 0.765625C10.5322 0.765625 9.12608 1.02967 7.82605 1.51202V24.0192C9.12608 24.5016 10.5322 24.7656 12 24.7656C18.6274 24.7656 24 19.393 24 12.7656Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82611 16.9395C10.1313 16.9395 12 15.0708 12 12.7656C12 10.4605 10.1313 8.59174 7.82611 8.59174C5.52094 8.59174 3.65222 10.4605 3.65222 12.7656C3.65222 15.0708 5.52094 16.9395 7.82611 16.9395Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47827 10.6786V13.2873C5.47827 14.584 6.5294 15.6352 7.8261 15.6352C9.1228 15.6352 10.1739 14.584 10.1739 13.2873V10.6786H5.47827Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82608 14.07C7.39455 14.07 7.04346 13.7189 7.04346 13.2873V12.2439H8.60866V13.2874C8.60866 13.7189 8.25757 14.07 7.82608 14.07Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_341_12349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.765625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtFlag);
export default __webpack_public_path__ + "static/media/pt-flag.ab65f3fb236ca32158d26705a7d5abe1.svg";
export { ForwardRef as ReactComponent };